<template>
  <!--::banner topo::-->
  <section v-if="bannerTopo != ''" class="breadcrumb">
    <div class="img-avance">
      <img :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem" class="bg-img-fill" alt="">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="breadcrumb_iner">
            <div class="breadcrumb_iner_item">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--::sobre nos::-->
  <section v-if="sobre != ''" class="team_part">
    <div class="container">
      <div class="row align-items-stretch">
        <div class="col-lg-6 p-0 hidden-sm hidden-xs">
          <div class="team_img">
            <img :src="$imgURL + sobre[0].insInstitucionalImagens[0].itgUrlImagem" alt="">
          </div>
        </div>
        <div class="offset-lg-1 col-lg-5 align-self-center">
          <div class="team_member_text">
            <h2>{{ sobre[0].itiNome }}</h2>
            <p v-html="sobre[0].itiResumo1"></p>
          </div>
        </div>
        <img :src="$imagens + 'section_overlay.png'" class="section_pattern">
      </div>
    </div>

  </section>

  <!--::missao visao::-->
  <section v-if="missaoVisao != ''" class="missao_part">
    <div class="container">
      <div class="row">
        <div v-for="missao in missaoVisao" :key="missao.itiId" class="col-lg-4 col-md-6 mb-4 mb-lg-0">
          <div class="missao_card">
            <h3>{{ missao.itiNome }}</h3>
            <p v-html="missao.itiResumo1"></p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--::depoimentos::-->
  <div class="review_part" id="testimonial">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-lg-7">
          <div class="section_tittle">
            <h1>O que dizem nossos clientes</h1>
          </div>
        </div>
      </div>
      <div v-if="depoimentos && depoimentos.length > 0" class="row">
        <div class="col-lg-12">

          <Swiper :navigation="false" :pagination="{ clickable: true }" :slides-per-view="2" :space-between="40"
            :breakpoints="{ 768: { slidesPerView: 2 }, 0: { slidesPerView: 1 } }">
            <SwiperSlide v-for="depo in depoimentos" :key="depo.itiId">

              <div class="review_part_text ">
                <div class="singler_eview_part">
                  <div class="client_info">
                    <img :src="$imgURL + depo.insInstitucionalImagens[0].itgUrlImagem" alt="">
                    <h4>{{ depo.itiNome }}</h4>
                  </div>
                  <p v-html="depo.itiResumo1"></p>
                </div>
              </div>

            </SwiperSlide>
          </Swiper>

        </div>
      </div>
    </div>
  </div>

  <PageCallAction></PageCallAction>


</template>

<script>
import PageCallAction from '../components/PageCallAction.vue';
import { useHead } from '@vueuse/head';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
  name: 'SobreView',

  components: {
    PageCallAction,
    Swiper,
    SwiperSlide,
  },

  data: () => ({
    bannerTopo: [],
    sobre: [],
    missaoVisao: [],
    depoimentos: [],
  }),

  methods: {
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
    
    carregaMetas(texto, titulo) {
      useHead({
        title: 'Garante Max :: ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
  },

  created() {
    this.carregaMetas("---");

    // TOPO BANNER
    axios.get('/Process/InsInstitucional/institucional/11/toposobre/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML, this.bannerTopo[0].itiNome);
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // SOBRE
    axios.get('/Process/InsInstitucional/institucional/38/apresentacao/0/x')
      .then(response => {
        this.sobre = response.data;
        //console.log('sobre')
        //console.log(this.sobre)
      })
      .catch(error => {
        console.error(error);
      });

    // MISSAO VISAO
    axios.get('/Process/InsInstitucional/institucional/14/itensdosobre/0/x')
      .then(response => {
        this.missaoVisao = response.data;
        //console.log('missaoVisao')
        //console.log(this.missaoVisao)
      })
      .catch(error => {
        console.error(error);
      });

    // DEPOIMENTOS
    axios.get('/Process/InsInstitucional/institucional/42/depoimentos/0/x')
      .then(response => {
        this.depoimentos = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        //console.log('depoimentos')
        //console.log(this.depoimentos)
      })
      .catch(error => {
        console.error(error);
      });

  }

}
</script>

<style scoped></style>